import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiRequest } from '../lib/api';

export type PlanRecord = {
  id: string;
  title: string;
  description: string | null;
  file_name: string | null;
  file_path: string | null;
  download_url: string | null;
  is_current: boolean;
  start_date: string; // ISO date string (YYYY-MM-DD)
  end_date: string | null; // ISO date string (YYYY-MM-DD) or null if active
  activation_count: number; // Number of times this plan has been activated
  last_activated_at: string; // ISO timestamp
  shared_at: string | null;
  created_at: string | null;
  updated_at: string | null;
};

async function fetchPlans(
  clientId: string,
  accessToken: string | null | undefined,
) {
  return apiRequest<PlanRecord[]>(
    `/api/clients/${clientId}/plans`,
    { method: 'GET' },
    accessToken,
  );
}

export function useClientPlans(clientId: string) {
  const { session } = useAuth();

  return useQuery<PlanRecord[]>({
    queryKey: ['plans', clientId],
    enabled: Boolean(clientId && session),
    queryFn: () => fetchPlans(clientId, session?.access_token),
  });
}

export function useInvalidatePlans(clientId: string) {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: ['plans', clientId],
    });
}
